import { useState, useEffect } from 'react';
import { logger } from '../lib/logger';

interface HotelConfig {
  id: string;
  slug: string;
  baseUrl: string;
}

export function useHotelConfig(): HotelConfig {
  const [config, setConfig] = useState<HotelConfig>({
    id: '650e1059-753d-4ac2-a961-e7f1eb298e14', // Default fallback ID
    slug: 'hotel-r-de-paris',                  // Default fallback slug
    baseUrl: ''                                // Default fallback baseUrl
  });

  useEffect(() => {
    const isDevelopment = import.meta.env.DEV;

    if (window.HOTEL_CONFIG) {
      logger.debug('Using hotel config from window.HOTEL_CONFIG', {
        category: 'Configuration',
        data: {
          id: window.HOTEL_CONFIG.id,
          slug: window.HOTEL_CONFIG.slug,
          baseUrl: window.HOTEL_CONFIG.baseUrl,
          isDevelopment,
          timestamp: new Date().toISOString()
        }
      });

      let effectiveBaseUrl = isDevelopment ? '' : window.HOTEL_CONFIG.baseUrl || '';

      // Remove trailing slash if present
      if (effectiveBaseUrl.endsWith('/')) {
        effectiveBaseUrl = effectiveBaseUrl.slice(0, -1);
      }

      setConfig({
        id: window.HOTEL_CONFIG.id,
        slug: window.HOTEL_CONFIG.slug,
        baseUrl: effectiveBaseUrl
      });
      return;
    }

    // Fallback extraction from URL if HOTEL_CONFIG not defined
    const pathParts = window.location.pathname.split('/');
    const slugFromUrl = pathParts[1] || 'hotel-r-de-paris'; // default if missing

    logger.debug('Extracted hotel config from URL fallback', {
      category: 'Configuration',
      data: {
        slug: slugFromUrl,
        path: window.location.pathname,
        isDevelopment,
        timestamp: new Date().toISOString()
      }
    });

    const effectiveBaseUrl = isDevelopment ? '' : `/${slugFromUrl}`;

    setConfig({
      id: '650e1059-753d-4ac2-a961-e7f1eb298e14',
      slug: slugFromUrl,
      baseUrl: effectiveBaseUrl
    });
  }, []);

  return config;
}
